import LongText from '../Elements/LongText';
import React from 'react';

export default class ServiceFromItem {
  constructor(item) {
    if (item) {
      this.ServiceDisplayName = item.serviceDisplayName;
      this.OpportunityDisplayName = item.opportunityDisplayName;
      this.ClientDisplayName = item.clientDisplayName;
      this.ServiceId = item.serviceId;
      this.Selected = false;
      return;
    }
    this.ServiceDisplayName = '';
    this.OpportunityDisplayName = '';
    this.ClientDisplayName = '';
    this.ServiceId = '';
    this.Selected = false;
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Selected', orderById: '', data: ServiceFromItem.getSelectedCellContent, minWidth: 20 },
      { label: 'Service', orderById: 'Name', data: ServiceFromItem.getServiceCellContent, minWidth: 70 },
      {
        label: 'Opportunity',
        orderById: 'OpportunityName',
        data: ServiceFromItem.getOpportunityCellContent,
        minWidth: 70
      },
      { label: 'Client', orderById: 'ClientName', data: ServiceFromItem.getClientCellContent, minWidth: 70 }
    ];
  }

  static getServiceCellContent(item) {
    return <LongText text={item.ServiceDisplayName ? item.ServiceDisplayName : ' '} maxLength={30} />;
  }

  static getOpportunityCellContent(item) {
    return <LongText text={item.OpportunityDisplayName ? item.OpportunityDisplayName : ' '} maxLength={30} />;
  }

  static getClientCellContent(item) {
    return <LongText text={item.ClientDisplayName ? item.ClientDisplayName : ' '} maxLength={30} />;
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='radio'
          checked={item.Selected}
          onClick={(e) => {
            ServiceFromItem.clickOnSelect(item);
          }}
          onChange={(e) => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  static clickOnSelect(item) {
    alert('Click');
  }
}
